var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackRub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55854 11V0.290039H4.37854C5.68854 0.290039 6.65854 0.555039 7.28854 1.08504C7.92854 1.61504 8.24854 2.38504 8.24854 3.39504C8.24854 4.07504 8.09354 4.66004 7.78354 5.15004C7.47354 5.63004 7.01354 6.00004 6.40354 6.26004C5.80354 6.52004 5.05854 6.65004 4.16854 6.65004H2.90854V11H1.55854ZM0.25354 8.96004V7.98504H5.38354V8.96004H0.25354ZM0.25354 6.65004V5.51004H3.68854V6.65004H0.25354ZM3.97354 5.51004C4.58354 5.51004 5.09854 5.44504 5.51854 5.31504C5.94854 5.18504 6.27854 4.97004 6.50854 4.67004C6.73854 4.37004 6.85354 3.96004 6.85354 3.44004C6.85354 2.76004 6.64354 2.25504 6.22354 1.92504C5.80354 1.59504 5.14854 1.43004 4.25854 1.43004H2.90854V5.51004H3.97354Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRub);
export default __webpack_public_path__ + "static/media/blackRub.2e23cb7ff2ea9a7e30fcda928d70b54c.svg";
export { ForwardRef as ReactComponent };